<div class="align-right">
  <button mat-button color="primary" (click)="addCountry()">
    <mat-icon>add_circle_outline</mat-icon>
    <span> add </span>
  </button>
</div>
<div class="table-container">
  <table mat-table [dataSource]="countries" matSort>

    <ng-container matColumnDef="code">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'admin.countries.code' |translate}}</th>
      <td mat-cell *matCellDef="let country">{{country.code}}</td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'admin.countries.name' |translate}}</th>
      <td mat-cell *matCellDef="let country">{{country.name}}</td>
    </ng-container>

    <ng-container matColumnDef="region">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'admin.countries.region' |translate}}</th>
      <td mat-cell *matCellDef="let country">{{country.region}}</td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let country">
        <mat-icon (click)="editCountry(country)" color="primary"
                  matTooltip="Edit" matTooltipPosition="above">edit
        </mat-icon>
        <mat-icon *ngIf="country.status === 'ACTIVE'" color="primary"
                  matTooltip="Disable" matTooltipPosition="above"
                  (click)="updateCountry(country, false)">check_circle
        </mat-icon>
        <mat-icon *ngIf="country.status === 'INACTIVE'"
                  color="primary" matTooltip="Enable" matTooltipPosition="above"
                  (click)="updateCountry(country, false)">radio_button_unchecked
        </mat-icon>
        <mat-icon *ngIf="country.status === 'INACTIVE'"
                  color="primary" matTooltip="Delete" matTooltipPosition="above"
                  (click)="updateCountry(country, true)">delete
        </mat-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator color="primary" [length]="totalElements"
                 [pageSize]="pageSize"
                 (page)="onPageChange($event)"
                 [pageSizeOptions]="pageSizes">
  </mat-paginator>
</div>
